<template>
  <div v-if="loading" class="sidebar-content-container">
    <TheLoader :active="true"/>
  </div>
  <div v-else-if="!loading && items.length < 1" class="sidebar-content-container">
    <TheEmptyList :title="'Ingen kundenotater'" :message="'Kundenotater kan brukes som interne merknader som ikke er synlig for kunden.'" :large="false" :icon="'button-glyph-comment'"/>

    <div class="grid-x toolbar input" style="margin-bottom: 4.5rem;">
      <form @submit.prevent="handleSubmit" style="width: 100%">
        <div class="cell">
          <div class="input-container" style="margin-bottom:1rem">
            <textarea
              autocomplete="off"
              placeholder="Legg til kundenotat…"
              v-model="newNotat"
              v-validate="'required|max:500'"
              name="Notat"
              :disabled="$store.getters.isFormProcessing"
              :class="{ 'error': errors.has('Notat') }"></textarea>
          </div>
        </div>
        <div class="cell">
          <div class="grid-x" style="width: 100%;">
            <!-- <TheSwitchInput containerClassName="cell auto" switchContainerStyle="margin: 0" :small="true" :align="'left'" labelTrue="Send til regnskap" labelFalse="Send til regnskap" :trueValue="true" :falseValue="false"/> -->
            <div class="cell auto"></div>
            <div class="cell shrink">
              <a href="javascript:;" style="margin: 0" v-if="$store.getters.isFormProcessing" class="button primary loading"><span class="button-title">Lagrer</span> <span class="loader-spinner"></span></a>
              <a href="javascript:;" style="margin: 0" v-else-if="!isFormSubmittable()" class="button primary disabled"><span class="button-title">Lagre</span></a>
              <a href="javascript:;" style="margin: 0" v-else @click="handleSubmit()" class="button primary"><span class="button-title">Lagre</span></a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <overlay-scrollbars v-else :options="{ className: 'sidebar-content-container os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <div class="messages-container">
      <div class="message" v-for="item in filteredItems" v-bind:key="item.id">
        <div class="message-avatar">
          <span class="avatar name right" :class="strToAvatarClass(item.bruker.initials)" v-if="item.bruker">
            {{item.bruker.initials}}
            <span class="name">{{item.bruker.full_name}}</span>
          </span>
          <!-- Fallback to registret-av if no bruker found -->
          <span class="avatar name right" :class="strToAvatarClass('-')" v-else>
            {{item.Registrert_av}}
            <span class="name">{{item.Registrert_av}}</span>
          </span>
        </div>
        <div class="message-content">
          <p>{{item.Notat}}</p>
          <div class="message-timestamp"><time>{{item.Registrert_tid | avantidatenice}}</time></div>
          <!--a v-if="item.bruker && item.bruker.Brukerid === getUser.Brukerid" href="javascript:;" @click="deleteNotat(item, index)" class="message-delete">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg>
            Slett
          </a-->
        </div>
      </div>

      <div class="message" v-if="items.length > 0">
        <div style="width: 100%; text-align: center; margin-top: 10px" v-if="!everythingLoaded && pageCount > 1">
          <button href="javascript:;" @click="loadMore()" class="button secondary action glyph" v-if="!loading && !updating">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
            <span>Last fler</span>
          </button>
          <button href="javascript:;" class="button secondary action glyph loading" v-else>
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
            <span>Laster fler <span class="loader-spinner"></span></span>
          </button>
        </div>
        <div style="width: 100%; text-align: center; margin-top: 10px; font-size: 0.8em" v-else>
          Alt har blitt lastet inn
        </div>
      </div>
    </div>

    <div class="grid-x toolbar input" style="margin-bottom: 4.5rem;">
      <form @submit.prevent="handleSubmit" style="width: 100%">
        <div class="cell">
          <div class="input-container" style="margin-bottom:1rem">
            <textarea
              autocomplete="off"
              placeholder="Legg til kundenotat…"
              v-model="newNotat"
              v-validate="'required|max:2000'"
              name="Notat"
              :disabled="$store.getters.isFormProcessing"
              :class="{ 'error': errors.has('Notat') }"></textarea>
          </div>
        </div>
        <div class="cell">
          <div class="grid-x" style="width: 100%;">
            <!-- <TheSwitchInput containerClassName="cell auto" switchContainerStyle="margin: 0" :small="true" :align="'left'" labelTrue="Send til regnskap" labelFalse="Send til regnskap" :trueValue="true" :falseValue="false"/> -->
            <div class="cell auto"></div>
            <div class="cell shrink">
              <a href="javascript:;" style="margin: 0" v-if="$store.getters.isFormProcessing" class="button primary loading"><span class="button-title">Lagrer notat</span> <span class="loader-spinner"></span></a>
              <a href="javascript:;" style="margin: 0" v-else-if="!isFormSubmittable()" class="button primary disabled"><span class="button-title">Lagre notat</span></a>
              <a href="javascript:;" style="margin: 0" v-else @click="handleSubmit()" class="button primary"><span class="button-title">Lagre notat</span></a>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="expandable-search" style="margin-bottom: 3.8rem;" :class="{'active': searchBoxActive, 'search-active': search != ''}" v-if="!loading && items.length > 0">
      <div class="input-container search no-margin comment">
        <input  class="rounded" type="text" placeholder="Søk i kundenotater…" v-model="search" v-on:keydown="onSearchInput" v-on:blur="toggleSearchbox(false)" v-on:focus="toggleSearchbox(true)">
        <button class="glyph-button" type="submit">Søk <svg width="14px" height="14px" viewBox="0 0 14 14"><use xlink:href="/static/sprites.svg#glyph-input-search"></use></svg></button>
        <a href="javascript:;" @click="clearSearch()" class="cancel-search"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
      </div>
    </div>
  </overlay-scrollbars>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'KundeCardSidebarTabNotater',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1, // Just for the pagination component
      newNotat: '',
      search: '',
      searchBoxActive: false
    }
  },
  created () {
    this.setFormLoading(false)

    // Set current page
    this.currentPage = this.queryParams.page || 1

    // Debounced input
    this.onSearchInput = this._.debounce(this.onSearchInput, 500)
  },
  computed: {
    ...mapGetters(['getUser']),
    ...mapGetters('kundenotat', [
      'items',
      'pageCount',
      'totalCount',
      'everythingLoaded',
      'queryParams',
      'loading',
      'updating'
    ]),
    filteredItems: function () {
      if (!this.search) {
        return this.items
      }

      return this.items.filter((i) => {
        return this._.includes(this._.toLower(i.Notat), this.search)
      })
    }
  },
  methods: {
    clearSearch: function () {
      this.search = ''
      this.toggleSearchbox(false)
    },
    toggleSearchbox: function (mode) {
      if (mode === false) {
        this.searchBoxActive = this.search !== ''
      } else {
        this.searchBoxActive = true
      }
    },
    onSearchInput: function (e) {
      // In it's own method, so we can have debounce
      this.search = this._.toLower(e.target.value.trim())
    },
    loadMore: function () {
      let page = this.currentPage + 1

      if (page > this.pageCount) {
        return
      }

      // Make query to load more...
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = page
      copiedParams.page = this.currentPage

      this.$store.dispatch('kundenotat/reload', {
        Kundenr: this.kunde.Kundenr,
        queryParams: copiedParams
      }).then((response) => {
      })
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre kundenotat', 'Vennligst korriger feil i skjemaet')
          } else {
            let payload = {
              Kundenr: this.kunde.Kundenr,
              Notat: this.newNotat
            }

            const prevValue = this.newNotat

            this.$store.dispatch('kundenotat/save', payload)
              .then(() => {
                this.newNotat = ''
                this.setFormProcessing(false)
              })
              .catch(() => {
                this.newNotat = prevValue
                this.$helpers.showErrorAlert('Kunne ikke lagre kundenotat', 'Vennligst prøv igjen')
                this.setFormProcessing(false)
              })
          }
        })
    },
    deleteNotat: function (item, index) {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      let payload = {
        Kundenr: this.kunde.Kundenr,
        id: item.id
      }

      this.$store.dispatch('kundenotat/delete', payload)
        .then(() => {
          this.$helpers.showSuccessAlert('Kundenotat er slettet')
          this.setFormProcessing(false)
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Kunne ikke slette kundenotat', 'Vennligst prøv igjen')
          this.setFormProcessing(false)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardSidebarTabNotater.vue